import React from "react";
import projects from "../projects.json";

export default React.createContext(projects);